module.exports = __webpack_public_path__ + "97c824a1e7506cc82e159557d11f042c.png";